<template>
    <div class="mt-2" v-if="currentJourney">

        <div class="w-100">
            <div>
                <div class="container">
                        <div class="row">
                            <div class="col-12 ">
                                <div  v-for="(item, index) in breakdownList"
                                :key="index"
                                >
                               <div class="row pt-3 pb-2 mt-n1 pricing-breakdown-information">
                                    <div class="col-8">
                                        <p >{{ item.agency_name }}</p>
                                    </div>
                                </div>
                                <p>Accepted payment methods for this operator:</p>
                                <ul class="col-8 pt-2">
                                    <li v-for="(method, index) in item.methods" :key="index">
                                    {{ method }}
                                    </li>
                                </ul>
                                <hr>
                            </div>
                            </div>
                        </div>
                 </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
    data() {
        return {
            showingJourneyType: 'depart',
            showingReturnType: false,
        }
    },
    props: {
        journeyType: {
            type: String,
            default: 'depart',
        },
        showingReturn: {
            default: true,
            type: Boolean,
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
            'user',
        ]),
        ...mapGetters([
            'getIconNamesByStage',
        ]),
        icons() {
            return this.getIconNamesByStage(this.showingJourneyType)
        },
        breakdownList() {
            return this.currentJourney.payment_methods_breakdown
        },


    },

}
</script>
<style lang="scss">

    .save-button-section{border-radius: 0px 0px 9px 9px;}

</style>
